import React, { useState } from "react";
import { Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import styles from "./ContactMessageList.module.css";
import { BsTrash } from "react-icons/bs";
import { FaRegUser } from "react-icons/fa";
import { useModals } from "@mantine/modals";
import { Modal, TextInput, Textarea } from "@mantine/core";
import { Text } from "@mantine/core";
import { toast } from "react-toastify";

const ContactMessageList = ({ contacts }) => {
  const [list, setList] = useState(contacts === null ? [] : contacts);
  const [modalOpened, setModalOpened] = useState(false);
  const [singleMessageDetail, setSingleMessageDetail] = useState({});
  const modals = useModals();

  const [searchText, setSearchText] = useState("");

  const searchHandeler = (text) => {
    if (text !== "") {
      setList(
        contacts.filter((item) => {
          return item.name.toLowerCase().includes(text.toLowerCase());
        })
      );
    } else {
      setList(contacts);
    }
    setSearchText(text);
  };

  // DELETE HANDELER
  const deleteHandeler = (id) =>
    modals.openConfirmModal({
      title: "Delete this message?",
      centered: true,
      children: (
        <Text size="md">
          Are you sure you want to delete this message? This action is
          destructive and you can not undo it.
        </Text>
      ),
      labels: { confirm: "Delete", cancel: "Cancel" },
      confirmProps: { color: "red" },
      onCancel: () => {},
      onConfirm: () => confirmHandeler(id),
    });

  // On CONFIRM DELETE
  const confirmHandeler = async (id) => {
    // let check = await deleteProduct(id);
    // if (check === true) {
    //   toast.success("Product deleted successfully");
    //   navigate("/dashboard");
    // } else {
    //   toast.error("Something went wrong");
    // }

    toast.success("Confirmed!");
  };

  // MODAL HANDELER
  const handleModal = (messageDetail) => {
    setSingleMessageDetail(messageDetail);
    setModalOpened(true);
  };

  return (
    <Container className="py-4">
      <Modal
        centered
        size="lg"
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        title={<b>Message detail!</b>}
      >
        <>
          <TextInput
            label="Name"
            placeholder="Name"
            value={singleMessageDetail.name}
          />
          <TextInput
            label="Contact Email"
            placeholder="Email"
            value={singleMessageDetail.email}
          />
          <TextInput
            label="Company Name"
            placeholder="Company"
            value={singleMessageDetail.companyName}
          />
          <TextInput
            label="Country"
            placeholder="Country"
            value={singleMessageDetail.country}
          />
          <Textarea
            autosize
            minRows={2}
            maxRows={10}
            label="Message"
            placeholder="Message"
            value={singleMessageDetail.message}
          />
        </>
      </Modal>
      <div className="d-flex justify-content-between align-items-center pb-3 ">
        <div className="d-flex align-items-center w-100">
          <span className="d-block fs-4">Search Contacts</span>
          <Form.Control
            type="text"
            placeholder="Search contact by name..."
            className={`${styles.searchInput}`}
            onChange={(e) => searchHandeler(e.target.value)}
            value={searchText}
          />
        </div>
      </div>

      <Card className="crd p-md-4 pb-md-0 p-2">
        <Card.Body>
          {contacts === null ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: 600 }}
            >
              <Spinner variant="dark" animation="grow" />
            </div>
          ) : (
            <>
              {list && list && list.length === 0 && (
                <span className="d-block text-center fs-4 lead pb-4">
                  No contact Found
                </span>
              )}
              {list &&
                list.map((messageDetail, i) => (
                  <Row
                    key={messageDetail._id}
                    className={`mb-3 pb-3 ${
                      list.length - 1 === i ? "" : "border-bottom"
                    }`}
                  >
                    <Col md={2}>
                      <Row>
                        <Col
                          md={7}
                          className={`${styles.small} d-flex align-items-center`}
                        >
                          <div className={styles.img_wrapper}>
                            <FaRegUser color="#fff" />
                          </div>
                        </Col>
                        <Col
                          md={3}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <div className={styles.line}></div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={9} className="">
                      <div className="d-flex align-items-center h-100">
                        <span
                          className={` fw-bold ${styles.link}`}
                          onClick={() => handleModal(messageDetail)}
                        >
                          {messageDetail.name}
                        </span>
                      </div>
                    </Col>

                    {/* <Col
                      md={1}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <span
                        className={`ms-3 fw-bold fs-4 ${styles.link}`}
                        onClick={() => deleteHandeler(messageDetail._id)}
                      >
                        <BsTrash className="text-danger" />
                      </span>
                    </Col> */}
                  </Row>
                ))}
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ContactMessageList;
